import { render } from "./App.vue?vue&type=template&id=3f6c5aaf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3f6c5aaf&lang=css"

import exportComponent from "/Users/zhangmohan/work/activitymarketing-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__